import React from "react";
import DMCalendar from "./DMCalendar";
import "../assets/css/DigixLeads.css";
import "../assets/css/Projects.css";
import "../assets/css/MyDay.css";
import "./dm/dm.css";
import "../assets/css/PageHeading.css";

/**
 * Standalone CRM page: Digital Marketing only (DM calendar + tenant filter).
 * Same calendar component is embedded on the Dashboard "DM Calendar" tab.
 */
function DigitalMarketingPage() {
  return (
    <div className="dmp">
      <div className="co-page-head">
        <h2 className="co-page-head__title">DM Calendar</h2>
      </div>
      <div className="dmp-card dmp-card--calendar">
        <DMCalendar title={null} />
      </div>
    </div>
  );
}

export default DigitalMarketingPage;
